module.exports = __webpack_public_path__ + "img/etiquetado6.d16c8108.jpg";